import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs';
import { DialogCallbacks } from '../dialog-common.interface';

export interface CancellationRequestDialogData extends DialogCallbacks {
  servicePhoneNumber: string;
  studentPhoneNumber: string;
  confirm$: Observable<any>;
  title: string;
  description: string;
  phone: string;
  confirm: string;
  editNumber: string;
  confirmationTitle: string;
  confirmationDescription: string;
  confirmationClose: string;
}

const NAVIGATE_TO_PROFILE_EVENT = 'NAVIGATE_TO_PROFILE';

@Component({
  template: `
    <pp-shell-dialog [title]="data.title | translate">
      <div class="confirmation" *ngIf="showConfirmation">
        <mat-icon class="check-icon">check</mat-icon>
        {{data.confirmationTitle | translate}}
      </div>
      <div *ngIf="!showConfirmation; else cancellationContent" mat-dialog-content>
        <p class="description">
          {{data.description | translate:
            ({ servicePhoneNumber: data.servicePhoneNumber })
          }}
        </p>
        <ng-container *ngIf="data.studentPhoneNumber">
          <span class="call">{{data.phone | translate}}</span>
          <span class="number">{{ data.studentPhoneNumber }}</span>
        </ng-container>
      </div>
      <ng-template #cancellationContent>
        <div mat-dialog-content>
          <p class="description confirmation-description">
            {{data.confirmationDescription | translate:
              ({ servicePhoneNumber: data.servicePhoneNumber })
            }}
          </p>
        </div>
      </ng-template>
      <div mat-dialog-actions *ngIf="!showConfirmation; else cancellationActions">
        <button (click)="onConfirm()" class="loading-btn" mat-flat-button color="accent">
          {{data.confirm | translate}}<mat-spinner *ngIf="isLoading" diameter="18" color="accent"></mat-spinner>
        </button>
        <button (click)="navigateToProfile()" class="call-me">{{data.editNumber | translate}}</button>
      </div>
      <ng-template #cancellationActions>
        <div class="confirmation-actions" mat-dialog-actions>
          <button mat-dialog-close mat-flat-button color="accent">{{data.confirmationClose | translate}}</button>
        </div>
      </ng-template>
    </pp-shell-dialog>
  `,
  styleUrls: ['./cancellation-request.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancellationRequestDialogComponent {
  public isLoading = false;
  public showConfirmation = false;
  constructor(
    public dialogRef: MatDialogRef<CancellationRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancellationRequestDialogData,
    private cdRef: ChangeDetectorRef
  ) { }

  public onConfirm() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.data.confirm$.subscribe(
        (res) => {
          this.isLoading = false;
          this.showConfirmation = true;
          this.cdRef.markForCheck();
          if (this.data.onSuccess) {
            this.data.onSuccess(res);
          }
        },
      );
    }
  }

  public navigateToProfile() {
    if (!this.isLoading) {
      window.parent.postMessage({ type: NAVIGATE_TO_PROFILE_EVENT }, '*');
    }
  }
}
